

import Vue from "vue";
import { ProductService } from "@/services/product-service";
import { StockLocationConfig } from "@/models/dossier-configs/stock-location";
import { DossierConfigService } from "@/services/dossier-config-service";
import { Product, ProductStock, StockIn } from "@/models/base";
import { StockService } from "@/services/stock-service";
import { BookYearService } from "@/services/book-year-service";
import { ISelectItem } from "winfakt-vue-components";
import {SellCategories} from "@/models/dossier-configs/sell-categories";

interface IVisibleCategories {
	categoryName: string;
	category: number;
}

export default Vue.extend({
	data() {
		return {
			text: "",
			product: null as Product | null,
			toggleStockDetail: false,
			togglePrices: false,
			qty: 0,
			type: 1,
			config: DossierConfigService.getStockScannerConfig(),
			visiblePrices: [] as IVisibleCategories[],
		};
	},
	props: {

	},
	computed: {
		title():string{
			let i = this.items.filter(i => i.value == this.type);
			return i[0].text.toString();
		},
		priceCategories(): SellCategories {
			return DossierConfigService.getSellCategories();
		},
		stockLocationConfig():StockLocationConfig {
			return DossierConfigService.getStockLocationConfig();
		},
		actualStock():any {
			if (!this.product) {
				return;
			}
			let productStock = new ProductStock(this.product.Stock) as any;
			return this.stockLocationConfig.getSortedLocationNames().map((l: string, i: number) => {
				return {
					text: l,
					value: i + 1,
					stock: productStock["Location" + (i + 1) + "Qty"]
				} as any;
			});
		},
		totalStock():number{
			if (!this.product) {
				return 0;
			}
			let totalStock = 0;
			let productStock = new ProductStock(this.product.Stock) as any;
			this.stockLocationConfig.getSortedLocationNames().forEach((l: string, i: number) => {
				if(this.config.CalculateLocations.includes(i+1)){
					totalStock += productStock["Location" + (i + 1) + "Qty"] as any;
				}
			});
			return totalStock;

		},
		items():ISelectItem<number>[]{
			return [
				{text: this.$ct("add-difference"), value: 1},
				{text: this.$ct("add-stock"), value: 2},
				{text: this.$ct("remove-stock"), value: 3}
			];
		},
	},
	methods: {
		computeVisibleCategories() {
			this.visiblePrices = [];
			let cats = this.priceCategories.getCategories();
			for (let cat of cats) {
				if (cat.Active) {
					let catNumber = cats.indexOf(cat) + 1;
					this.visiblePrices.push({
						categoryName: this.priceCategories.getCategoryName(catNumber),
						category: catNumber
					});
				}
			}
		},
		setType(type:number){
			this.type = type;
			localStorage.setItem("scan-type", type.toString());
		},
		cancel(){
			this.$emit("close");
		},
		async fetch(){
			try {
				const scanned = await ProductService.findBySku(this.text);
				if (this.type === 2 && this.product && scanned && scanned.ID === this.product.ID) {
					this.qty += 1;
				} else {
					this.product = scanned;
					this.qty = 1;
				}
			}catch(err){
				this.product=null;
			}
			this.clearOnFocus();
			(this.$refs.barcode as HTMLElement).focus();
		},
		clearOnFocus(){
			this.text = "";
			this.toggleStockDetail = false;
		},
		async save(){
			let t = this.type == 1 ? (this.qty - this.totalStock) : this.qty;
			if(this.type==3 && this.qty > 0){
				t = this.qty *-1;
			}
			let stock = new StockIn({
				LocationID: 1,
				Name: this.product?.Name,
				ProductID: this.product?.ID,
				Sku: this.product?.Sku,
				Qty: t,
				UnitBuyPrice: this.product?.BuyCatalogPrice,
				DateCreated: new Date(),
				BookYear: BookYearService.selectedBookYear
			});

			await StockService.saveStock([stock]);
			this.$wf.notify(this.$ct("save-success").toString(), "success", 3000, "check");
			this.qty = 0;
			this.product=null;
			(this.$refs.barcode as HTMLElement).focus();
		}
	},
	mounted() {
		this.type = parseInt(localStorage.getItem("scan-type") || "1") ;
		this.computeVisibleCategories();
	},
	destroyed() {

	},
	components: {
	},
	i18nEx: {
		componentPrefix: "components.stock.scan"
	}
});
